const withdrawalAgreement = {
  id: 'withdrawal-agreement-ru',
  title: 'Соглашение о выводе средств',
  body: `
  <ol>
    <li>Банк-корреспондент может взимать комиссию за начисление средств. Пожалуйста, уточняйте наличие и размер комиссии  в своем банке.</li>
    <li>Если вывод средств производится не в исходной валюте Партнерского кабинета (российские рубли), то при выводе будет выполнена конвертация. Конвертация валюты производится по актуальному курсу Европейского центрального банка в день зачисления средств.</li>
    <li>Вывод средств производится только на банковскую карту или счет лица, указанного при верификации в Партнерском кабинете. Вывод средств на счета третьих лиц не осуществляется.</li>
    <li>
      Для вывода средств необходимо предоставить документы и реквизиты.
      <ol>
        <li>Для вывода средств юридическим лицам необходимо предоставить следующие документы: ИНН, ОГРН (для резидентов Российской Федерации) или аналогичные документы (для резидентов других стран), банковские реквизиты на почту tatyanak@super-ego.info и заполнить заявку далее.</li>
        <li>Для вывода средств на банковскую карту необходимо ввести ее реквизиты на специальной странице платежного сервиса (соответствует стандартам безопасности данных индустрии платежных карт PCI DSS ) и заполнить заявку далее. Мы не храним и не обрабатываем данные ваших банковских карт.</li>
      </ol>
    </li>
    <li>Комиссия при выводе средств на банковскую карту составляет 4% от указанной в заявке суммы.</li>
    <li>С начисленных средств необходимо самостоятельно оплатить налог согласно ставке, установленной страной проживания.</li>
    <li>Средства поступают на банковскую карту или счет в течение 10 рабочих дней (приблизительное время, точные сроки зависят от вашего банка).</li>
  </ol>
  <p>По вопросам вывода денежных средств просим обращаться в Службу Компетентной Поддержки либо по телефону +79662406130 (звонок может быть платный, уточняйте стоимость звонка у своего сотового оператора).</p>
  `
}

export default withdrawalAgreement
